import { v4 as uuidv4 } from 'uuid';
// 基础消息角色枚举
export const MessageRoleEnum = {
    System: 'system',
    User: 'user',
    Assistant: 'assistant',
    Narrator: 'narrator',
};
// 工具函数
export function createGameMessage(role, content, characterId) {
    return {
        id: uuidv4(),
        role,
        content,
        timestamp: Date.now(),
        characterId,
    };
}
export function createGameCharacter(template) {
    return {
        ...template,
        currentState: {
            health: 100,
            mood: 'neutral',
            location: 'starting_area',
            inventory: [],
            attributes: {},
        },
        experience: 0,
        level: 1,
    };
}
export function createGameSession(script, character, sessionName) {
    return {
        id: uuidv4(),
        scriptId: script.id,
        scriptName: script.name,
        name: sessionName || `${script.name} - ${new Date().toLocaleDateString()}`,
        currentCharacter: character,
        messages: [],
        gameState: {
            currentScene: script.initialScene,
            availableActions: [],
            inventory: [],
            stats: {},
            flags: {},
            variables: {},
            worldState: {
                time: 'morning',
                location: 'starting_area',
            },
        },
        savePoints: [],
        settings: {
            aiModel: {
                provider: 'openai',
                model: 'gpt-4',
                temperature: 0.7,
                topP: 1,
                stream: true,
            },
            autoSave: true,
            autoSaveInterval: 5,
            showChoices: true,
            showStats: true,
            narrationStyle: 'second-person',
            difficulty: 'medium',
            language: 'en',
            theme: 'auto',
            ...script.defaultSettings,
        },
        stats: {
            totalMessages: 0,
            playTime: 0,
            choicesMade: 0,
        },
        createdAt: Date.now(),
        updatedAt: Date.now(),
        lastPlayedAt: Date.now(),
        isActive: false,
        isCompleted: false,
    };
}
export function createSavePoint(session, name, description, isAutoSave = false) {
    return {
        id: uuidv4(),
        name,
        description,
        sessionId: session.id,
        messageIndex: session.messages.length,
        gameState: JSON.parse(JSON.stringify(session.gameState)), // 深拷贝
        character: JSON.parse(JSON.stringify(session.currentCharacter)), // 深拷贝
        timestamp: Date.now(),
        isAutoSave,
    };
}
